const mytext = `die Luftwaffe
das Amerika
der Amerikaner
der Amerikaner
der April
das Asien
der August
das Australien
der Australier
das Österreich
der Unterleib
die Fähigkeit
das Ausland
das Gaspedal
der Unfall
das Unglück
der Komplize
der Bericht
das Konto
das Konto
der Buchhalter
der Akku
die Anklage
die Beschuldigung
das As
die Bekanntschaft
die Aktivität
der Schauspieler
der Schauspieler
die Schauspielerin
die Schauspielerin
der Zusatz
die Adresse
die Adresse
der Empfänger
die Anpassung
die Verwaltung
der Eintritt
der Eintritt
der Erwachsene
die Anzeige
die Werbung
der Ratschlag
der Berater
das Flugzeug
die Angelegenheit
das Rasierwasser
der Nachmittag
das Alter
die Agentur
der Agitator
die Abmachung
der Vertrag
die Landwirtschaft
das Hilfsmittel
die Sicht
das Ziel
die Luftpost
die Luft
der Flugplatz
die Fluggesellschaft
der Flieger
der Flughafen
das Luftschiff
der Gang
der Wecker
der Alkohol
die Algebra
der Alligator
die Beihilfe
die Änderung
die Alufolie
das Aluminium
der Botschafter
der Krankenwagen
der Krankenwagen
der Vorfahr
der Engel
der Zorn
der Zorn
der Angler
das Angeln
das Tier
das Knöchel
der Ansager
die Antwort
die Ameise
die Antiquität
die Sorge
der Aperitif
das Gerät
das Aussehen
das Erscheinen
der Anhang
das Blinddarm
der Appetit
der Apfel
der Bewerber
die Bewerbung
die Verabredung
die Anerkennung
der Lehrling
das Aquarium
der Archäologe
die Archäologie
die Gegend
der Streit
das Argument
das Rechnen
der Arm
der Arm
der Lehnstuhl
die Armee
die Vereinbarung
die Ankunft
der Pfeil
die Kunstgalerie
die Kunst
die Kunst
die Arthritis
die Artikel
der Gegenstand
der Künstler
der Maler
die Künstlerin
die Asche
der Aschenbecher
das Aspirin
der Attentäter
die Montage
die Hilfe
der Assistent
der Verband
der Verband
die Mischung
das Sternchen
das Sportler
die Leichtathletik
die Luft
die Atmosphäre
der Anfall
der Anschlag
der Versuch
die Aufmerksamkeit
die Haltung
die Versteigerung
der Zuschauer
das Auditorium
die Tante
der Herbst
der Herbst
die Straße
das Durchschnitt
das BASIC
das Brasilien
der Brasilianer
der Buddha
das Baby
der Rücken
die Rückseite
das Rückgrat
der Hintergrund
die Bakterien
die Tasche
der Bäcker
der Saldo
der Waage
das Gleichgewicht
der Balkon
der Ball
das Ballett
der Kugelschreiber
der Bambus
die Banane
die Gruppe
die Band
die Kapelle
das Band
der Verband
die Verbannung
das Ufer
der Feiertag
der Bank
der Geldschein
die Taufe
die Tafel
die Bar
das Lokal
der Friseur
das Bellen
die Rinde
die Gerste
die Grundlage
der Baseball
die Schüssel
der Korb
das Bad
das Bad
das Bad(ezimmer)
der Akku
die batterie
der Strand
die Bohne
der Bär
der Bart
das Bett
das Bett
das Schlafzimmer
die Biene
das Rind
der Bienenstock
das Bier
der Bettler
der Anfang
das Wesen
die Klingel
die Glocke
die Glocke
der Bauch
der Gürtel
die Bank
die Biegung
die Kurve
der Vorteil
die Verlobung
das Fahrrad
das Fahrrad
das Bidet
der Bikini
die Rechnung
das Vogelbauer
das Vogel
der Kugelschreiber
der Geburtstag
der Keks
das Stück
die Tafel
die Klinge
die Decke
der Blinde
die Augenbinde
die Blindheit
das Blut
das Löschpapier
die Bluse
der Schlag
das Brett
die Pension
das Internat
das Schiff
die Gruppe
der Körper
die Nackenrolle
der Knochen
die Motorhaube
die Haube
das Buch
das Bücherregal
der Fahrkartenschalter
die Vorverkaufskasse
das Bücherbord
die Buchhandlung
der Kofferraum
der Stiefel
die Langeweile
der Chef
der Botaniker
die Botanik
die Mühe
die Flasche
die Flasche
der Bodem
das Boulevard
der Rausschmeißer
die Boutique
die Schüssel
die Kasse
der Karton
die Kiste
der Junge
das Armband
die Hirn
die Bremse
der Ast
die Branche
die Marke
der Kognak
das Brot
die Ruhepause
die Panne
das Frühstück
die Brust
der Atem
der Ziegelstein
die Brücke
die Kollegmappe
der Rand
die Sendung
die Rundfunkstation
das Bordell
der Bruder
der Bruder
der Bruder
die Bürste
der Eimer
die Knospe
der Buddhismus
das Gebäude
der Stier
die Stoßstange
der Einbrecher
das Einbruch
die Beerdigung
die Bushaltestelle
der Bus
der Busch
die Aangelegenheit
der Betrieb
das Geschäft
der Geschäftsmann
die Fleischerei
der Fleischer
die Butter
der Schmetterling
das Knopfloch
der Knopf
der Käufer
das Kanada
der Kanadier
die CD
das China
das China
der Chinese
das Chinesisch
der Weinachtsbaum
das Weihnachten
das Kabarett
der Kohl
das Kabel
das Café
die Cafeteria
der Käfig
der Kuchen
das Kalb
die Kamera
das Lager
das Camping
der Kanal
die Kerze
das Kanu
die Kantine
die Mütze
die Fähigkeit
die Hauptstadt
die Kapsel
der Kapitän
das Auto
der Wagen
die Karaffe
der Wohnwagen
der Wohnwagen
der Vergaser
die Karte
die Versorgung
die Karriere
der Hausmeister
der Frachter
die Fracht
der Parkplatz
der Tischler
die Teppich
die Teppich
der Kutsche
der Wagen
der Wagen
die Fahrbahn
der Wagen
der Zeichentrickfilm
die Karikatur
das Etui
der Fall
der Koffer
die Kasse
der Geldautomat
das Bargeld
der Kassierer
die Burg
das Schloss
der Verunglückte
die Katze
die Raupe
der Blumenkohl
der Grund
die Vorsicht
die Decke
der Zement
das Friedhof
der Zentimeter
die Zentralheizung
die Mitte
das Zentrum
das Jahrhundert
die Zeremonie
das Zeugnis
die Kette
der Stuhl
der Präsident
der Vorsitzender
der Kalkstein
die Kreide
das Zimmermädchen
der Champagner
die Gelegenheit
die Möglichkeit
der Zufall
das Kleingeld
die Veränderung
der Kanal
der Charakter
die Persönlichkeit
die Holzkohle
der Angriff
die Aufgabe
die Gebühr
der Charme
der Talisman
das Fahrgestell
der Chauffeur
das Schachmatt
die Backe
der Käse
die Apotheke
die Drogerie
der Apotheker
der Chemiker
die Chemie
das Scheckbuch
der Scheck
die Kirsche
die Kommode
die Brust
das Huhn
das Huhn
das Kind
das Kind
die Kindheit
die Kinder
die Erkältung
der Schornstein
das Kinn
das Porzellan
die Schokolade
die Auswahl
das Stäbchen
die Taufe
der Vorname
die Kirche
die Zigarre
das Zigarettenetui
die Zigarette
das Kino
die Zirkulation
das Rathaus
die Stadt
die Zivilisation
der Anspruch
der Verschluss
die Klasse
die Klasse
die Klasse
die Kralle
der Raumpfleger
die Raumpflegerin
die Reinigung
die Reinigung
der Büroangestellte
das Klima
die Klinik
die Garderobe
die Uhr
die Stillegung
die Sperrung
die Kleider
das Kleid
die Wolke
der Clown
das Kreuz
der Club
die Kupplung
der Wagen
der Trainer
der Bus
die Kutsche
die Kohle
die Küste
der Kleiderbügel
der Mantel
der Hahn
der Kakao
der Kakao
der Kaffee
das Stück
das Stück
das Stück
der Zufall
die Erkältung
der Schnupfen
der Kragen
der Kollege
der Mitarbeiter
der Zusammenstoß
der Kolonist
die Kolonie
die Farbe
die Säule
die Spalte
der Kamm
die Komödie
der Trost
das Komma
der Befehl
der Handel
die Ausschusssitzung
die Kommunikation
die Kommunikation
der Kommunismus
der Kommunist
der Begleiter
die Firma
die Firma
die Gesellschaft
der Vergeleich
das Abteil
die Konkurrenz
der Wettbewerb
die Klage
die Klage
die Gesichtsfarbe
die Komplikation
das Kompliment
der Bestandteil
der Komponist
das Kompott
der Computer
das Konzert
das Ende
der Schluss
der Beton
die Bedingung
die Verhältnisse
der Zustand
der Kondom
der Dirigent
der Schaffner
die Konferenz
die Beschlagnahme
die Konfrontation
die Glückwunsch
der Kongress
der Anschluss
die Beziehung
die Verbindung
der Kenner
das Bewusstsein
die Zustimmung
der Konservatismus
der Konsul
das Konsulat
die Konsultation
die Besprechung
die Kontaktlinsen
der Behälter
der Inhalt
der Kontinent
der Vertrag
die Annehmlichkeit
das Gespräch
das Kabriolett
der Koch
die Kockkunst
das Kochen
das Kupfer
der korken
das Korn
die Ecke
die Ecke
die Leiche
die Korrespondenz
der Korridor
die Kosten
das Kostüm
das Baumwollgarn
die Watte
die Baumwollstoff
die Baumwollstoff
die Couch
der Hustensaft
der Husten
der Ladentisch
der Schalter
das Landhaus
das Land
das Land
der Mut
der Kursus
der Lauf
der Hof
die Cousine
der Vetter
die Kuh
der Cowboy
die Geschicklichkeit
die Preiselbeere
der Kran
die Sahne
der Schöpfer
die Kreditkarte
die Kremation
das Krematorium
die Besatzung
das Kricket
die Verbrechen
die Krise
die Chips
die Kritik
das Geschirr
das Krokodil
das Hörnchen
die Feldfrucht
die Kreuzung
die Menge
die Krone
der Schrei
der Würfel
die Manschette
die Manschettenknöpfe
die Kultur
der Pokal
die Tasse
der Schrank
die Neugier
die Wissbegier
die Locke
der Lebenslauf
der Lehrplan
das Currygericht
der Vorhang
das Kissen
die Angewohnheit
der Kunde
der Zollbeamte
der Zoll
das Besteck
das Rad
der Zyklus
das Radfahren
der Däne
das Dänisch
der Dezember
das Dänemark
der Holländer
das Holländisch
der Niederländer
der Papa
die Dahlie
der Schaden
der Tanz
der Tänzer
das Tanzen
das Armaturenbrett
die Datenbank
das Dattel
das Datum
die Verabredung
die Tochter
der Tagesanbruch
der Tag
der Tag
der Tod
der Schuldposten
die Entscheidung
das Deck
der Anstreicher
die Niederlage
der Fehler
der Grad
das Vergnügen
die Lieferung
die Demokratie
der Zahnartz
das Kaufhaus
die Abteilung
die Abfahrt
der Designer
das Desktoppublishing
der Schreibtisch
der Nachtisch
das Reiseziel
die Einzelhet
das Reinigungsmittel
der Tau
das Diagramm
der Dialekt
das Karo
das Diktat
das Wörterbuch
die Ernährung
die Schlankheitskur
der Unterscheid
der Unterscheid
die Schwierigkeit
die Abmessung
der Krach
der Speisewagen
das Eßzimmer
das Abendessen
das Abendessen
das Diplom
die Diplomatie
der Diplomat
die Richtung
die Richtung
der Direktor
der Regisseur
der Leiter
die Enttäuschung
die Katastrophe
die Diskothek
die Unhöflichkeit
der Entdecker
die Entdekung
die Besprechung
die Ausschiffung
die Schande
das Gericht
die Schüssel
die Unehrlichkeit
das Diskettenlaufwerk
die Entfernung
die Entfernung
die Ehre
der Unterscheid
das Gebiet
die Störung
der Graben
das Tauchen
das Dock
der Artz
der Doktor
das Dokument
das Hundehalsband
der Hund
die Puppe
der Dollar
der Delfin
der Esel
die Tür
der Pförtner
der Eingang
der Punkt
das Doppelbett
der Zweifel
das Drama
die Schublade
der Salon
die Zeichnung
der Traum
das Kleid
der Morgenrock
die Frisierkommode
die Scneiderin
das Getränk
der Chauffeur
der Fahrer
der Fahrer
das Fahren
das Rückspiegel
die Fahrschule
der Tropfen
die Droge
der Drogist
die Ente
die Ente
die Düne
der Staub
die Mülltonne
der Zoll
der Zoll
der Dienst
die Pflicht
der Farbstoff
das Ostern
das Ägypten
der Ägypter
das England
das England
das Englisch
der Engländer
das Europa
das Ohr
der Ohrring
die Erde
das Erdbeben
das Behagen
der Osten
die Wirtschaftswissenschaften
der Wirtschaftswissenschaftler
die Wirtschaft
der Rand
die Ausbildung
die Erziehung
der Effekt
das Ei
der Ellenbogen
der Elektrorasierer
die Elektrizität
der Strom
die E-mail
die Botschaft
der Notfall
das Gefühl
der Kaiser
das Reich
die Kaiserin
die Leere
das Ende
der Schluss
das Ende
der Schluss
der Feind
die Energie
die Verlobung
der Motor
der Motor
der Ingenieur
der Genuss
die Begeisterung
der Eingang
der Umschlag
der Neid
der Epilog
das Nachwort
der  quator
die Epoche
der Radiergummi
die Besorgung
der Irrtum
die Rolltreppe
der Aufsatz
die Schätzung
die Etikette
der Euro
der Abend
das Ereignis
das Examen
das Beispiel
die Ausnahme
das Übermaß
die Börse
der Wechselkurs
der Austausch
die Aufregung
die Entschuldigung
das Schulheft
die Übung
die Ausstellung
der Verbannte
das Exil
der Ausgang
die Ausgabe
die Kosten
die Spesen
die Erfahrung
das Experiment
der Fachmann
die Erklärung
die Explosion
die Ausfuhr
der Export
der Scnellzug
die Ausdehnung
der Augenarzt
das Auge
die Augenwimper
der Februar
das Finnland
die Finnin
der Finn
das Finnisch
das Frankreich
das Französisch
der Franzose
der Freitag
das Gesicht
die Tatsachte
die Wirklichkeit
die Fabrik
die Fabrik
der Fall
die Gebiss
die Familie
die Verwandtschaft
der Fan
der Ventilator
der Fanatiker
das Kostüm
die Abschiedsfeier
der Bauernhof
der Bauer
der Hof
die Mode
das Fett
der Vater
der Vater
der Fehler
die Schuld
das Fax
die Angst
der Feiertag
das Fest
die Feder
die Feder
der Eindruck
das Gefühl
das Gefühl
der Filzstift
das Fechten
die Fähre
die Fähre
das Fest
das Fieber
der Verlobte
das Feld
das Feld
der Kampf
die Akte
der Aktenschrank
der Film
der Film
der Film
die Geldstrafe
der Finger
die Feuerwehr
der Brand
das Feuer
das Feuer
der Kamin
die Feuerwerkskörper
der Betrieb
die Firma
die Erste-Hilfe-Ausrüstung
der Fisch
das Fischereigebiet
das Fischerboot
die Angelrute
das Fischgeschäft
der Fischhändler
die Fahne
die Fahnenstange
der Blitz
die Wohnung
der Geschmack
der Flachs
der Floh
das Fleisch
der Flug
die Überschwemmung
der Boden
die Etage
der Stock
die Diskette
der Blumenhändler
das Mehl
die Blume
die Fliege
das Fliegen
der Nebel
das Laubwerk
das Taufbecken
die Schrift
die Schrift
das Essen
der Dummkopf
der Fuß
das Fußball
der Fußabdruck
die Kraft
die Prognose
der Zeigefinger
die Stirn
das Ausland
die Fremdsprache
der Wald
der Wald
die Verzeihung
die Gabel
die Klasse
die Form
die Form
das Formular
das Formular
die Förmlichkeit
das Glück
das Vermögen
die Fundament
der Füllfederhalter
das Foyer
der Bruch
der Franken
der Franken
die Freiheit
der Chip
der Kühlschrank
der Freund
der Freund
die Freundlichkeit
die Freundschaft
die Angst
der Schreck
das Kleid
der Obstbaum
die Frucht
das Obst
die Pfanne
der Brennstoff
der Punkt
der Spaß
die Beerdigung
das Fell
die Möbel
der Zukunft
das Deutsch
der Deutscher
das Deutschland
das Großbritannien
das Großbritannien
das Griechenland
der Grieche
das Griechisch
das Gerät
der Gewinn
die Galerie
das Spiel
das Spiel
die Bande
der Haufen
die Kolonne
die Ganster
der Gang
die Laufplanke
die Lücke
die Autowerkstatt
die Garage
der Garten
der Gärtner
der Knoblauch
das Gas
der Pförtner
das Tor
die Verssamlung
die Generation
der Herr
der Geograf
die Geografie
die Geometrie
das Geschenk
das Geschenk
der Ingwer
das Mädchen
der Blick
das Glas
die Brille
der Erdball
der Handschuh
die Ziege
der Gott
das Gold
der Golfplatz
das Golf
die Ware
die Ware
die Ware
die Gans
der Feinschmecker
die Regierungsstelle
der Staatsbeamter
die Regierung
die Grammatik
die Enkelin
das Enkelkind
das Enkelkind
der Großvater
die Großmutter
die Großeltern
der Enkel
die Weintraube
die Grapefruit
die Pampelmuse
das Grafik
das Gras
der Grab
das Friedhof
die Soße
das Fett
die Gier
der Gemüsehandler
der Gruß
das Erdgeschoss
der Boden
die Gruppe
die Gruppe
die Gruppe
die Garantie
die Garantie
der Schaffner
die Pension
das Gästezimmer
der Gast
der Rat
der Führer
die Schuld
die Gitarre
das Gummi
das Turnen
das Hebräisch
das Holland
das Holland
die Gewohnheit
das Haar
das Haar
die Haarbürste
der Friseur
der Friseursalon
die Hälfte
die Halbzeit
die Diele
die Halle
die Halle
der Schinken
die Hand
die Handtasche
die Handarbeit
das Taschentuch
das Griff
der Hörer
das Glück
der Hafen
die Festplatte
die Hardware
die Ernte
die Hast
der Hut
der Hutständer
das Heu
der Kopf
die Kopfschmerzen
die Schlagzeile
der Schulleiter
die Gesundheit
die Gesundheit
das Gehör
das Herz
das Herz
der Kern
die Hitze
die Heizung
der Himmel
die Hecke
der Absatz
die Ferse
die Größe
die Höhe
die Hilfe
die Portion
der Hanf
die Henne
das Kraut
der Held
die Heldin
das Versteck
der Hochsprung
die Oberschule
die Flut
der Hang
der Hügel
die Behinderung
die Geschichte
das Hockey
die Hacke
das Loch
der Urlaub
die Ferien
das Heim
das Heim
das Heimweh
die Hausaufgaben
die Ehrlichkeit
der Honig
der Angelhaken
der Haken
der Horizont
das Horn
die Hupe
die Vorspeise
das Pferd
das Krankenhaus
die Gastfreundschaft
der Gastgeber
die Gastberin
die Wärmflasche
das Hotel
das Hotel
die Stunde
das Haus
das Haus
die Hausfaru
die Hausarbeit
der Mensch
der Hunger
der Mann
der Mann
die Hütte
der Hypochonder
die Heuchelei
der Heuchler
das Island
das Indien
der Inder
das Irland
der Irländer
das Israel
der Israeli
der Italiener
das Italienisch
das Italien
das Eis
das Eis
die Ahnung
die Idee
die Vorstellung
der Dummkopf
die Zündung
die Krankheit
die Illustration
die Veranschaulichung
die Phantasie
der Imperialismus
die Unhöflichkeit
die Wichtigkeit
die Einfuhr
der Import
der Eindruck
die Verbesserung
der Vorfall
die Neigung
die Unannehmlichkeit
der Richtungsanzeiger
der Einzelner
die Industrie
der Einfluss
das Auskunftsbüro
die Auskunft
die Information
der Bewohner
der Einwohner
die Initiale
die Tinte
das Gasthaus
das Inselk
die Eingeweide
die Schlaflosigkeit
der Kontrolleur
der Unterricht
die Anweisungen
der Lehrer
das Instrument
das Instrument
die Beleidigung
die Kasse
die Absicht
die Zinsen
das Interesse
die Einmischung
das Innere
das Internet
der Dolmetscher
die Pause
die Pause
die Pause
das Interview
das Interview
die Intonation
die Einleitung
die Vorstellung
der Invalide
die Erfindung
der Erfinder
die Einladung
die Rechnung
das Bügeleisen
das Eisen
das Bügeln
die Insel
der Januar
das Japan
der Japaner
das Japanisch
der Jude
das Jordanien
der Juli
der Juni
der Bube
der Wagenheber
die Marmelade
der Hausmeister
der Kiefer
der Jazz
der Edelstein
der Beruf
die Stellung
der Witz
das Joker
der Journalist
die Fahrt
die Reise
die Freude
der Richter
das Judo
der Krug
der Saft
das Gerümpel
der Ramsch
der Schlüssel
die Tastatur
das Schlüsselloch
der Kilometer
die Sorte
der Kindergarten
der Konig
der König
der Kuß
die Küche
der Bube
das Knie
das Messer
das Stricken
der Griff
der Schlag
der Knoten
die Kenntnis
die Krone
das Latein
die Arbeit
der Arbeiter
der Bursche
die Leiter
die Dame
der See
das Lamm
die Lampe
der Lanternenpfahl
der Lampenschirm
das Land
das Land
das Land
die Landung
die Landung
der Treppenabsatz
der Vermieter
die Landschaft
die Sprache
das Lachen
das Lachen
der Waschsalon
die Wäscherei
die Wäsche
die Toilette
der Gerichtshof
das Recht
der Rasen
das Blatt
das Leck
die Erziehung
die Studie
die Lederware
das Leder
das Urlaub
das Bein
die Gesandtschaft
die Legende
die Freizeit
die Zitrone
die Limonade
die Lektion
der Buchstabe
der Briefkasten
der Brief
der Kopfsalat
die Bibliothek
die Genehmigung
der Deckel
die Lüge
das Leben
das Leben
der Lift
das Feuer
die Glühbirne
das Licht
das Licht
der Lichtstrahl
das Feuerzeug
die Vorliebe
der Flieder
das Maiglöckchen
die Lilie
die Grenze
die Limousine
die Linie
das Leinen
der Sprachkundiger
die Sprachwissenschaft
die Lippe
der Lippenstift
der Likör
die Liste
die Literatur
die Leber
das Wohnzimmer
das Wohnzimmer
das Darlehen
das Darlehen
das Schloss
die Lokomotive
der Weitsprung
der Lastwagen
der Schaden
der Verlust
die Lotterie
die Liebe
die Geliebte
der Geliebter
die Ebbe
das Glück
das Gepäck
der Klumpen
das Mittagessen
das Mittagessen
die Lunchbox
die Lunge
die Text
der März
der Mai
das Fräulein
der Montag
der Herr
die Frau
der Maschinenkode
die Maschine
die Maschinen
der Verrückter
die Zeitschrift
das Dienstmädchen
die Post
das Hauptgericht
die Mehrheit
die Marke
das Make-up
der Mann
die Leitung
der Direktor
die Manie
der Wahnsinniger
die Maniküre
die Menschheit
die Weise
der Totschlag
die Landkarte
die Mark
die Note
das Zeichen
der Markt
die Ehe
das Ehepaar
das Meisterwerk
das Streichholz
der Wettkampf
der Stoff
der Mathematiker
die Mathematik
die Sache
die Majonäse
der Bürgermeister
der Bürgermeister
die Wiese
das Essen
das Essen
die Bedeutung
die Mittel
der Maßstab
die Menge
das Fleisch
das Fleisch
der Mechaniker
die Arznei
die Medizin
der Treffpunkt
die Begegnung
die Sitzung
das Mitglied
die Erinnerung
das Gedächtnis
das Menü
die Speisekarte
das Handelsschiff
der Dreck
das Durcheinander
die Mitteilung
der Bote
der Bote
das Metall
der Zähler
die Methode
das Verfahren
der Meter
die Metropole
die Mikrowelle
die Mitte
die Mitternacht
die Milch
der Geist
der Verstand
das Mineral
der Mineraloge
die Mineralogie
der Kleinbus
das Kleintaxi
der Pfarrer
der Minister
die Minute
das Wunder
der Spiegel
der Spiegel
das Pech
das Unglück
der Nebel
der Fehler
der Irrtum
das Missverständnis
die Mischung
das Stöhnen
der Wassergraben
das Funktelefon
das Modem
der Augenblick
der Moment
das Geld
der Geldverleiher
der Affe
der Monat
das Denkmal
die Laune
der Mond
der Morgen
der Vormittag
die Stechmücke
die Mutter
die Mutter
die Bewegung
der Motor
das Motorrad
die Autobahn
der Berg
die Maus
die Maus
der Schnurrbart
der Mund
das Schutzblech
die Mami
der Mord
der Mörder
der Muskel
das Museum
der Pilz
die Musik
der Musiker
die Niederlande
das Neujahr
der Neujahrstag
das Neuseeland
der Neuseeländer
das Norwegen
der Norweger
das Norwegisch
der November
der Nagel
der Nagel
die Nacktheit
der Name
die Serviette
die Nation
die Nationalität
der Einheimischer
die Naturalisation
die Natur
das Wesen
die Übelkeit
die Marine
die Nippflut
die Notwendigkeit
der Hals
die Halskette
die Nektar
die Nadel
die Handarbeit
der Nachbar
die Nachbarin
die Gegend
die Nähe
der Neffe
das Netz
die Nachricht
die Nachricht
die Neuwigkeit
der Zeitungsverleger
die Zeitung
die Nichte
die Nacht
das Kabarett
der Albtraum
der Krach
der Mittag
die Norm
der Norden
die Nase
der Geldschein
die Note
die Aufzeichnung
das Briefpapier
die Bekanntmachkung
das Schild
der Roman
der Ramanschriftsteller
die Anzahl
die Nummer
die Zahl
die Ziffer
die Krankenschwester
das Pflegeheim
der Occident
der Oktober
der Orient
das Objekt
das Ziel
der Einwand
die Pflicht
die Wahrnehmung
die Besessenheit
die Gelegenheit
die Besetzung
der Beruf
der Augenartz
das Angebot
der Bürogehilfe
das Amt
das Amt
das Büro
der Offizier
der Beamte
das lgemälde
das Erdöl
das Öl
die Salbe
das Alter
das Altersheim
das Ammenmärchen
die Zwiebel
die Oper
die Operation
die Unternehmung
die Vermittlung
die Operette
die Meinung
die Gelegenheit
der Widerstand
der Optiker
der Optimist
die Orange
der Obstgarten
das Orchester
die Bestellung
der Befehl
die Reihenfolge
die Organisation
der Orientale
die Ursprung
der Ziergegenstand
die Stadtrand
der Backofen
der Mantel
der Mantel
der Besitzer
der Ochs
das Turnen
die PIN-nummer
das Polen
der Pole
das Polnisch
das Portugal
die Portugiesin
der Portugiese
die Packung
die Seite
die Seite
der Page
der Schmerz
die Farbe
der Maler
der Anstreicher
das Bild
das Paar
das Schloss
die Pfanne
der Topf
das Papiergeld
das Papier
die Paketpost
das Paket
das Paket
die Begnadigung
die Eltern
die Eltern
der Park
die Rolle
der Teil
der Abschied
der Partner
die Partei
die Party
der Pass
der Gang
das Passagierboot
der Fahrgast
der Passagier
die Leidenschaft
der Reisepass
das Passwort
das Kennwort
die Vergangenheit
der Teig
der Zeitvertrieb
das Gebäck
der Weg
die Geduld
der Kranke
der Patient
die Ruhepause
der Bürgersteig
die Pfote
der Bauer
das Pfandrecht
das Pfandhaus
die Bezahlung
die Erbse
der Frieden
der Pfirsich
die Birne
der Bauer
der Fußgängerüberweg
der Fußganger
die Schale
die Feder
der Füller
der Elfmeter
die Strafe
der Bleistift
die Kalligraphie
die Leute
das Volk
der Pfeffer
das Prozent
die Vorstellung
das Parfum
der Zeitraum
die Zeitschrift
die Erlaubnis
die Genehmigung
der Person
der Person
die Persönlichkeit
die Überredung
der Pessimist
die Tankstelle
das Benzin
das Foto
der Fotograf
der Doktor
der Physiker
die Physik
das Klavier
das Piano
der Taschendieb
das Picknick
das Bilderbuch
die Abbildungspostkarte
das Bild
das Bild
das -stück
die Frömmigkeit
das Schwein
das Schweinchen
die Pille
die Pille
die Tablette
die Säule
der Kissenbezug
das Kissen
die Stecknadel
die Kiefer
das Tonsignal
die Pfeife
das Rohr
das Spielfeld
das Mitleid
der Platz
der Platz
der Plan
das Flugzeug
das Brett
die Pflanze
der Kunststoff
der Teller
der Teller
der Bahnsteig
das Podium
das Stück
das Spielen
der Spielplatz
der Sportplatz
die Freude
das Vergnügen
das Komplott
das Grundstück
die Handlung
das Pflug
die Pflaume
das Taschengeld
die Tasche
das Gedicht
der Dichter
der Punkt
das Gift
die Stange
die Polizeiwache
die Polizei
der Polizist
das Bohnerwachs
die Politur
der Politiker
die Politik
der Teich
die Armen
die Bevölkerung
das Porzellan
der Hafen
der Gepäckträger
der Teil
das Porträt
der Besitz
die Möglichkeit
das Postamt
die Post
die Briefmarke
das Porto
die Postkarte
das Plakat
der Briefträger
der Topf
die Kartoffel
der Töpfer
die Töpferei
das Geflügel
die Armut
der Puder
die Kraft
die Übung
das Lob
das Vorwort
die Vorbereitung
das Rezept
das Geschenk
der Direktor
der Präsident
die Druckerei
der Druck
der Preis
die Grundschule
der Premierminister
das Prinzip
die Drucksache
die Druckerei
der Drucker
das Drucken
die Privatschule
der Preis
das Problem
der Umzug
das Produkt
der Beruf
der Professor
das Programm
der Fortschritt
das Projekt
der Prolog
das Versprechen
die Aussprache
das Eigentum
der Heiratsantrag
der Vorschlag
die Prosa
die Prostitierte
der Protest
der Proviant
der Psychologe
die Psychologie
der Feiertag
das Publikum
der Verlag
der Pullover
der Puls
die Pumpe
die Reifenpanne
die Strafe
die Pupille
der Schüler
die Marionette
der Einkauf
das Ziel
die Geldbörse
der Pyjama
der QL
die Qualität
die Menge
der Streit
das Viertal
der Kai
die Dame
die Frage
die Frage
die Schlange
die Ruhe
die Stille
der Kostenvoranschlag
das Zitat
das Russland
der Russe
das Russisch
die Rennbahn
die Rasse
das Rennen
der Heizkörper
das Radio
der Rettisch
die Reling
die Eisenbahn
der Regen
der Regenbogen
der Regenmantel
die Harke
der Rang
der Ausschlag
die Ratte
das Rohmaterial
der Strahl
die Rasierklinge
der Rasierapparaat
der Realist
die Werklichkeit
die Rückseite
der Grund
der Grund
die Quittung
der Hörer
die Rezeption
die Sprechstundenhilfe
der Emfangschef
das Rezept
die Empfehlung
die Versöhnung
der Schallplatte
der Rekord
die Aufzeichnung
der Schiedsrichter
die Quellenangabe
die Referenz
die Erfrischung
der Kühlschrank
das Gebiet
das Bedauern
die Vorschrift
die Beziehung
der Verwandte
die Entspannung
die Erleichterung
die Religion
der Rest
das Heilmittel
die Miete
die Reparatur
das Repertoire
die Antwort
der Bericht
der Reporter
die Vertretung
der Vertreter
das Reptil
das Gesuch
die Rettung
der Retter
die Forschung
der Forscher
die Reservierung
die Wohnung
der Beschluss
der Bezug
der Respekt
die Verantwortung
die Pause
der Speisewagen
das Restaurant
der Ergebnis
das Resultat
das Resultat
die Pensionierung
die Rückfahrkarte
die Rückkehr
das Wiedersehen
der Aufstand
die Revolution
die Revue
die Belohnung
das Rheuma
der Reis
das Recht
der Ring
die Gehaltserhöhung
das Risiko
der Fluss
das Verkehrszeichen
die Straße
die Straße
die Fahrbahn
der Räuber
die Rolle
das Dach
der Platz
der Platz
das Zimmer
die Wurzel
die Rose
der Streit
die Reihe
die Tantiemen
der Radiergummi
das Gummiband
das Gummi
das Abvall
der Quatsch
der Schrott
das Rugby
die Vorschrift
das Laufen
der Samstag
der September
das Spanien
die Spanierin
der Spanier
das Spanisch
der Sonntag
der Schwede
das Schweden
der Schwedisch
der Schweizer
die Schweiz
der Sack
das Segel
das Segelboot
das Segeln
der Salat
das Gehalt
die Absatz
der Verkäufer
die Verkäuferin
das Salz
der Sand
das Sandwich
die Schärpe
die Freude
die Soße
der Topf
die Untertasse
das Sauerkraut
die Sauna
die Wurst
die Waage
die Scanner
das Tuch
die Landschaft
das Parfüm
der Gelehrte
der Schüler
die Schule
der Schuljunge
das Schulmädchen
die Natuurwissenschaft
der Wissenschaftler
die Schere
der Bildschirm
die Schraube
der Schraubenzieher
der Seevogel
das Meer
die Möwe
die Suche
das Meer
die Jahreszeit
die Saison
der Platz
das Stuhl
der Seetang
die Geheimhaltung
das Geheimnis
die Sekretärin
der Teil
der Beruhigungsmittel
der Samen
der Teil
die Auswahl
der Verkäufer
der Absender
das Gefühl
die Sensation
der Sinn
der Satz
das Urteil
die Sentimentalität
die Trennung
die Folge
der Diener
das Bedienungsgeld
die Tankstelle
die Bedienung
die Serviette
das Bühnenbild
das Sofa
das Abwasser
der Abwasserkanal
das Nähen
der Schatten
der Schatten
die Scham
die Form
die Form
die Garbe
der Schuppen
das Schaf
das laken
das Brett
die Muschel
das Schalentier
das Schalentier
der Sherry
das Schiff
die Werft
das Oberhemd
die Schuhgeschäft
der Schuh
der Schuhmacher
das Schaufenster
das Geschäft
das Geschäft
die Einkaufstasche
das Einkaufszentrum
die Einkäufe
der Fehler
die Schulter
die Ausstellung
der Schaukasten
die Dusche
der Schrein
die Seite
das Sideboard
der Anblick
das Augenlicht
das Sehvermögen
die Besichtigung
der Tourist
das Schild
das Zeichen
die Unterschrift
die Stille
die Seide
das Silber
die Einfachheit
die Sünde
die Sehne
der Sänger
das Singen
die Einzelfahrt
das Einzellbett
der Einzelgänger
das Spülbecken
die Sirene
die Schwester
die Schwester
die Schwester
die Schwägerin
das Wohnzimmer
der Zustand
die Größe
die Größe
die Größe
der Schlittschuh
das Skateboard
der Ski
das Skilaufen
die Haut
die Schale
der Rock
der Himmel
der Schlaf
der Schlafsack
die Schlaflosigkeit
der  rmel
der Schlitten
die Scheibe
das Dia
die Rutschbaan
der Pantoffel
der Hügel
der Automat
der Spielautomat
der Schlitz
der Geruch
das Lächeln
der Rauch
der Raucher
das Rauchen
die Schlange
das Niesen
der Snob
der Schnee
der Schneemann
die Seife
die Freundlichkeit
der Sozialismus
der Sozialist
die Gesellschaft
die Soziologie
die Socke
die Steckdose
das Sofa
die Software
die Erde
der Soldat
die Seezunge
die Sohle
die Sohle
die Einsamkeit
die Lösung
der Sohn
der Sohn
der Sohn
das Lied
die Halsschmerzen
die Sorte
die Seele
der Ton
die Suppe
die Suppe
die Quelle
der Süden
der Platz
der Raum
das Pik
der Spaten
der Ersatzteil
die Freizeit
die Freizeit
der Reserveriefen
das Reserverad
die Zündkerze
der Lautsprecher
der Redner
der Spezialist
die Spezialität
das Schauspiel
die Brille
der Zuschauer
die Rede
die Sprache
das Tempolimit
die Schnelligkeit
der Tachometer
der Zauber
die Schreibweise
das Gewürz
der Spinat
die Spirale
der Geist
die Seele
der Schwamm
der Löffel
das Sport
der Sportwagen
das Sportfest
das Sportler
der Punkt
die Tabellenkalkulation
die Nippflut
das Frühjahr
der Frühling
der Platz
das Quadrat
das Stall
das Personal
das Podium
der Fleck
die Treppe
die Treppe
die Treppe
das Patt
die Sackgasse
die Parkett
der Stempel
das Podium
der Maßstab
der Standpunkt
das Sternchen
der Stern
der Beginn
die Vorspeise
der Staat
der Zustand
der Zustand
der Bahnhof
der Schreibwarenhändler
die Schreibwaren
der Stationsvorsteher
die Statue
die Statur
das Statussymbol
das Prestige
der Aufenthalt
das Steak
das Diebstahl
der Dampfer
der Dampfzug
der Dampf
der Stahl
das Steuer
der Schritt
die Stufe
der Stethoskop
der Steward
die Stewardess
das Kompott
der Stock
der Strumpf
der Strumpf
die Magenschmerzen
die Magenschmerzen
der Bauch
der Magen
der Magen
der Stein
der Stöpsel
das Lager
die Etage
der Stock
die Geschichte
der Ofen
der Herd
der Fremde
die Erdbeere
der Bach
die Strömung
der Stadtplan
die Straße
die Straße
die Kraft
der Streik
die Schnur
das Spaziergang
der Student
die Einzimmerwohnung
das Atelier
das Studio
das Arbeitszimmer
das Studium
der Stil
der Vorort
der Vorort
der Erfolg
das Wildleder
der Zucker
die Zuckerdose
der Vorschlag
das Selbstmord
der Anzug
der Koffer
die Zusammenfassung
der Sommer
die Sonne
der Sonnenaufgang
der Sonnenuntergang
der Supermarkt
das Abendessen
die Beilage
der Zusatz
die Unterstützung
der Fan
der Anhänger
die Oberfläche
der Chirurg
die Chirurgie
das Sprechzimmer
der Familienname
die Überraschung
die Umgebung
der Pullover
das Bonbon
das Schwimmbad
die Badehose
das Schwimmen
der Badeanzug
der Schalter
das Schwert
das Symptom
der Kunststoff
der Sirup
das System
der Donnerstag
der Dienstag
der Türke
die Türkei
das Türkisch
die Tischdecke
die Tabelle
der Tisch
die Tablette
der Schwanz
der Schneider
das Gespräche
der Hahn
der Geschmack
der Taxifahrer
der Taxistand
das Taxi
der Tee
die Lehrerin
der Lehrer
die Teetasse
das Team
die Teekanne
die Träne
der Techniker
die Technik
der Teenager
das Telegramm
die Fernsprechzelle
der Anruf
das Telefonbuch
die Telefonzentrale
die Telefonnummer
das Telefon
der Fernseher
das Fernsehen
das Fieber
die Temperatuur
der Tempel
der Mieter
die Tendenz
das Tennis
das Zelt
das Semester
die Bedingung
die Endstation
die Terrasse
der Text
die Textilien
der Dank
das Theater
der Diebstahl
das Thermometer
die Thermosflasche
der Oberschenkel
die Sache
das Ding
das Drittel
der Durst
der Gedanke
der Faden
die Drohung
die Aufregung
der Hals
der Daumen
der Donner
das Gewitter
der Fahrkarte
der Fahrschein
die Karte
die Krawatte
die Fliese
der Ziegel
die Kachel
die Kasse
das Nutzholz
das Mal
die Zeit
die Zeit
die Zeit
die Zeit
der Fahrplan
der Dosenöffner
die Dose
das Zinnblech
der Tipp
die Spitze
das Trinkgeld
der Giftpilz
der Toast
der Toast
der Toaster
der Tabak
der Tabakhändler
der Tabakhändler
die Zehe
die Toilette
die Tomate
die Zunge
das Tonic
das Tonikum
die Mandel
das Werkzeug
der Werkzeugkasten
der Zahn
der Zahn
die Zahnschmerzen
die Zahnbürste
die Zahnpasta
der Tourist
das Handtuch
der Turm
das Rathaus
die Stadt
die Stadt
das Spielzeug
der Traktor
der Handel
der Händler
die Ampel
das Verkehrszeichen
der Verkehr
die Tragödie
der Zug
die Straßenbahn
der Beruhigungsmittel
das Geschäft
der Transistor
die Übersetzung
der Übersetzer
der Transport
das Reisebüro
das Reisen
der Reisender
der Reisescheck
das Tablett
der Genuss
die Behandlung
der Baum
der Versuch
die Fahrt
die Truppen
die Truppen
die Trophäe
die Mühe
die Schwierigkeiten
die Sorge
die Umstände
die Hose
die Forelle
der Trumpf
das Stamm
der Schrankkoffer
das Vertrauen
die Wahrheit
die Wahrheit
die Wäschwanne
die Tulpe
der Thunfisch
die Melodie
das Tunnel
der Truthahn
die Umdrehung
der Umsatz
die Schrift
die Schreibmaschine
die Schreibkraft
die Tyrannei
der Tyrann
der Reifen
die USA
der Abszess
das Geschwür
der Shirmständer
der Regenschirm
der Onkel
das Verständnis
die Unterwäsche
die Uniform
die Uniform
die Vereinigung
die Einheit
die Universität
die Unvernünftigkeit
die Dringlichkeit
der Gebrauch
der Platzanweiser
die Platzanweiserin
der Urlaub
das Tal
der Wert
der Lieferwagen
die Vase
das Kalbfleisch
das Gemüse
der Automat
das Unterhemd
die Umgebung
der Verunglückte
der Sieg
die Aussicht
die Besichtigung
die Villa
das Dorf
der Essig
das Veilchen
die Geige
der Virus
die Sicht
der Besuch
der Besucher
der Gast
die Stimme
der Mittwoch
die Taille
die Weste
die Wartezeit
der Kellner
der Kellner
der Kelner
das Wartezimmer
der Spaziergang
der Spazierstock
die Mauer
die Wand
die Brieftasche
der Krieg
der Kleiderschrank
das Lager
das Kriegsschiff
das Waschbecken
das Waschbecken
die Wäsche
der Abwasch
die Wespe
der Papierkorb
die Uhr
die Wache
der Wächter
der Wasserkrug
das Wasser
die Welle
das Wachs
der Eingang
der Ausgang
die Art
der Weg
die Wettervorhersage
das Wetter
das Wetter
die Website
der Hochzeitstag
die Hochzeit
die Woche
das Wochenende
das Gewicht
die Begrüßung
die Quelle
der Brunnen
der Westen
der Wal
der Weizen
das Rad
der Whisky
die Pfeife
die Breite
die Frau
die Frau
die Perücke
der Wind
die Windmühle
die Fensterscheibe
die Fensterbank
das Fenster
der Scheibenwischer
die Windschutzscheibe
der Weinkeller
der Weinhändler
der Wein
der Flügel
der Sieger
der Gewinner
der Winter
der Draht
der Wünsch
der Zeuge
die Frau
das Wunder
das Holz
der Wald
der Wald
die Holzarbeiten
die Wolle
das Textverarbeitungssystem
das Wort
das Werk
die Arbeit
die Arbeit
der Arbeiter
die Arbeitszeit
der Arbeiter
der Arbeitsplatz
die Werkstatt
die Welt
die Sorge
der Kranz
das Handgelenk
die Armbanduhr
der Schriftsteller
der Verfasser
das Schreibpapier
die Schrift
das Röntgenbild
die xenophobe
das Xylofon
der Hof
das Gähnen
das Jahr
das Jahr
die Jugend
der Jugendlicher
die Jugendherberge
das Zebra
der Reißverschluss
der Tierkreis
der Schwachkopf
der Zoo
der Zoologe
die Zoologie
das Zoomobjektiv`;

export default mytext ;
